import { takeLatest } from 'redux-saga/effects';
import * as types from './reducer';
import {getDashCardsSaga} from "./handler";

export default function* watchDashComponentsApi() {
    yield takeLatest(types.GET_DASH_CARDS, getDashCardsSaga);
}
